import { Box, Grid, Typography } from "@mui/material";
import JoinPremiumButton from "../Buttons/JoinPremiumButton/JoinPremiumButton";
import Image from "../../img/premium-image.png";

const JoinPremiumPopUp = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        padding: "2rem 1.5rem",
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", sm: "60%" },
        }}
      >
        <Box sx={{ marginBottom: "1rem" }}>
          <Typography
            variant="bannerTitle"
            sx={{
              fontSize: "2.5rem !important",
              color: "#3c3c40",
              fontWeight: "800 !important",
            }}
          >
            {"Want to get more out of "}
          </Typography>
          <Typography
            variant="bannerTitle"
            sx={{
              fontSize: "2.5rem !important",
              color: "#4663ff !important",
              fontWeight: "800 !important",
            }}
          >
            Collecticos?
          </Typography>
        </Box>
        <Box sx={{ marginBottom: "1rem" }}>
          <Typography
            variant="body1"
            sx={{
              fontSize: "1rem !important",
              color: "#3c3c40",
              fontWeight: "700 !important",
            }}
          >
            As a VIP member, you'll gain exclusive access to in-depth statistics
            about your football shirt collection. Track the total value of your
            shirts, compare current and original prices, analyze your collection
            by club, number of match worn shirts, and much more! Upgrade today
            and enjoy your hobby to the max!
          </Typography>
        </Box>
        <Box display="flex">
          <Box sx={{ width: { xs: "100%", md: "50%" } }}>
            <JoinPremiumButton text="Upgrade" />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          width: { xs: "100%", sm: "40%" },
          display: { xs: "none", sm: "block" },
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "15px",
          }}
        >
          <Box sx={{ width: { xs: "83.33%", md: "83.33%", lg: "83.33%" } }}>
            <img className="bannerImge" src={Image} alt={"banner image"} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default JoinPremiumPopUp;
